module.exports = __webpack_public_path__ + "img/13.890851ba.jpg";